import React from 'react'
import { Switch, Table } from 'antd'
import { connect } from 'react-redux'
import { actions } from '../../../../../store/reducers/assignment.reducer'
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'

const UnitTestsFilters = ({ filters, unitTestResults, isWaitingForUnitTestResults, setUnitTestsFilter }) => {
    const handlePassedSwitchClick = (recordId, checkedValue) => {
        const updatedUnitTestsFilters = filters.unitTests.map(unitTest =>
            unitTest.id === recordId ? { ...unitTest, passed: checkedValue } : unitTest,
        )
        setUnitTestsFilter(updatedUnitTestsFilters)
    }

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            render: name => <div style={{ maxWidth: 160, wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>{name}</div>,
        },
        {
            title: 'Passed',
            key: 'passed',
            dataIndex: 'passed',
            width: '24px',
            render: (_, record) => {
                let backgroundColor
                if (!record.enabled) {
                    backgroundColor = 'rgba(0, 0, 0, 0.25)'
                } else if (record.passed) {
                    backgroundColor = 'green'
                } else if (!record.passed) {
                    backgroundColor = 'red'
                }
                return (
                    <Switch
                        style={{ backgroundColor: backgroundColor }}
                        disabled={!record.enabled}
                        checked={record.passed}
                        onChange={checkedValue => handlePassedSwitchClick(record.key, checkedValue)}
                        checkedChildren={<CheckCircleOutlined />}
                        unCheckedChildren={<CloseCircleOutlined />}
                        aria-label={`show files that passed ${record.name} test`}
                    />
                )
            },
        },
    ]

    let data = []

    if (filters.unitTests.length && unitTestResults.length) {
        data = filters.unitTests.map(unitTest => ({
            enabled: unitTest.enabled,
            passed: unitTest.passed,
            key: unitTest.id,
            name: unitTest.name,
        }))
    }

    const rowSelection = {
        selectedRowKeys: filters.unitTests.map(unitTest => (unitTest.enabled ? unitTest.id : undefined)),
        onChange: selectedRowKeys => {
            const updatedUnitTestsFilters = filters.unitTests.map(unitTest => {
                if (selectedRowKeys.includes(unitTest.id)) return { ...unitTest, enabled: true }
                else return { ...unitTest, enabled: false }
            })
            setUnitTestsFilter(updatedUnitTestsFilters)
        },
        renderCell: (checked, record, _index, originNode) => {
            let ariaLabel
            if (checked) {
                ariaLabel = `Disable filtering by ${record.name} test`
            } else {
                ariaLabel = `Enable filtering by ${record.name} test`
            }
            return React.cloneElement(originNode, {
                'aria-label': ariaLabel,
            })
        },
    }

    return (
        <Table
            rowSelection={{
                ...rowSelection,
            }}
            columns={columns}
            dataSource={data}
            pagination={false}
            loading={isWaitingForUnitTestResults}
            locale={{
                emptyText:
                    filters.unitTests.length && !unitTestResults.length
                        ? 'Unit test results are not ready yet'
                        : 'There are no unit tests',
            }}
        />
    )
}

const mapState = ({ assignment }) => {
    return {
        filters: assignment.filters,
        unitTestResults: assignment.unitTestResults,
        isWaitingForUnitTestResults: assignment.isWaitingForUnitTestResults,
    }
}

const mapDispatch = dispatch => {
    return {
        setUnitTestsFilter(value) {
            dispatch(actions.setUnitTestsFilter(value))
        },
    }
}

export default connect(mapState, mapDispatch)(UnitTestsFilters)
